import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Map } from '@/features/map'

const mapSearchSchema = z.object({
  lat: z.string().optional(),
  lng: z.string().optional(),
  requestId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/map/')({
  validateSearch: mapSearchSchema,
  component: Map,
})
